import React from 'react';

function Home() {
    const containerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '85vh', // Full viewport height
    };

    const imageStyle = {
        maxWidth: '79%',
        maxHeight: '73%',
    };

    return (
        <div style={containerStyle}>
            <img src="/Pictures/Home.png" alt="Home Logo" style={imageStyle} />
        </div>
    );
}

export default Home;